import { createProjectApi, createSubprojectApi } from "@org-avp/avp-avengers-project-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { FetchBaseQueryArgs } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const baseQueryArgs: FetchBaseQueryArgs = {
  baseUrl: environment.NX_PROJECT_SERVICE_BASE_URL,
  prepareHeaders,
};

export const projectApi = createProjectApi({
  baseQueryArgs,
});
export const subprojectApi = createSubprojectApi({
  baseQueryArgs,
});
